import React from "react";

const TermsOfUse = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        className="modal fade show t-kvkkModal t-termsModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="termsModalTitle"
        aria-modal="true"
        style={{ display: "block", zIndex: 1055 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
          <div className="modal-content t-guarantorModal-content border-0">
            <div className="t-guarantorModal-header">
              <div className="t-guarantorModal-header-content">
                <div className="t-guarantorModal-icon">
                  <i className="t-icon-file-text2" aria-hidden="true" />
                </div>
                <div>
                  <h5 className="t-guarantorModal-title" id="termsModalTitle">
                    Kullanım Koşulları ve Gizlilik
                  </h5>
                  <p className="t-guarantorModal-subtitle">Web Sitesi Kullanım Koşulları</p>
                </div>
              </div>
              <button
                type="button"
                className="t-guarantorModal-close"
                onClick={onClose}
                aria-label="Kapat"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="t-guarantorModal-body t-kvkkModal-body">
              <div className="t-termsModal-content">
                <ol className="t-termsModal-list">
                  <li>
                    Bu web sitesine girmeniz veya bu web sitesindeki herhangi bir bilgiyi kullanmanız
                    aşağıdaki koşulları ve hükümleri kabul ettiğiniz anlamına gelmektedir.
                  </li>
                  <li>
                    Bu web sitesinin kullanımından doğan ve doğacak her türlü zarar ve/veya kayıplardan
                    dolayı Emin Şirketler Grubu (bundan böyle kısaca &apos;Eminevim&apos; olarak anılacaktır),
                    yönetim kurulu üyeleri, yöneticileri, çalışanları, bu sitede yer alan bilgileri
                    hazırlayan kişilerin ve Eminevim&apos;in yetkilendirdiği kişi ve kuruluşların hiçbir
                    hukuki ve cezai sorumluluğu bulunmamaktadır.
                  </li>
                  <li>
                    Eminevim bu yasal uyarıda yer alan tüm koşulları ve hükümleri önceden bir ihbara
                    gerek kalmaksızın değiştirme ve güncelleme hakkını haizdir.
                  </li>
                  <li>
                    Eminevim kullanıcılarının kişisel bilgilerinin gizliliğini korumaya özen gösterir.
                  </li>
                  <li>
                    İşbu Gizlilik Politikası, https://www.eminevim.com/ sitesi ile ilgili hizmetleri
                    sunarken, kişisel verilerinize ilişkin politikamızı içermektedir. Bu gizlilik
                    politikası kapsamında kural olarak kullanıcılarımız tarafından sitemize sunulan
                    kişisel veriler (adınız, elektronik posta adresiniz, iş ve özel adresiniz, telefon
                    numaralarınız vs) üçüncü kişilerle paylaşılmamakta, satılmamakta, kiralanmamakta ve
                    başka şekilde kullandırılmamaktadır. Eminevim söz konusu kişisel verileri sadece;
                    Kullanıcıların açık rızasına istinaden, Kullanıcılara katma değerli hizmetler,
                    fırsat ve olanaklar sunulması ve hizmet kalitesinin artırılması amacıyla; grup
                    şirketleri ile veya yasal bir zorunluluk gereği bu verileri talep etmeye yetkili
                    olan kamu kurum veya kuruluşları ile paylaşabilecektir. Tüm korumalara rağmen
                    Eminevim, kişisel bilgilerin sistemlerinden yasal olmayan yollarla elde
                    edilemeyeceğini garanti edemez ve ayrıca Eminevim&apos;in sistemlerinde güvenlik
                    açığı riski de dahil olmak üzere ortaya çıkabilecek tüm riskleri ve sorumluluğu kabul
                    etmiş sayılırsınız.
                  </li>
                  <li>
                    Bu web sitesinde yer alan, bunları içeren ama bunlarla sınırlı olmayan, tüm
                    sayfalar, fotoğraflar, dizaynlar, resimler gibi malzemeler ve bilgilere ilişkin telif
                    hakkı ve/veya diğer fikri mülkiyet hakları Eminevim&apos;e ait ve ilgili kanunlarca
                    korunmakta olup, bu malzemeler ve bilgiler izinsiz kullanılamaz, iktisap edilemez
                    ve değiştirilemez.
                  </li>
                  <li>
                    Kullanıcı veya Kullanıcılar, Web Sitesine girmeden önce yukarıda yer alan Web Sitesi
                    Kullanım Koşulları ve Gizlilik Politikasını okuduklarını, yukarıda belirtilen tüm
                    hususlara uyacaklarını, burada yer alan hususlarla ilgili olarak herhangi bir
                    uyuşmazlık veya ihtilaf iddia veya talep olduğu takdirde, İstanbul Anadolu Mahkeme ve
                    İcra Dairelerinin yetkili olacağını, Web Sitesinde yer alan içeriklerin ve
                    Eminevim&apos;e ait tüm elektronik ortam ve bilgisayar kayıtlarının HMK madde 193
                    uyarınca kesin delil sayılacağını gayrıkabili rücu olarak kabul, beyan ve taahhüt
                    etmişlerdir.
                  </li>
                </ol>
              </div>
            </div>

            <div className="t-guarantorModal-footer">
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--primary"
                onClick={onClose}
              >
                <span>Kapat</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
    </>
  );
};

export default TermsOfUse;
